
export default {
  name: 'ConfigurableFlexContainer',
  values: {
    flexDirection: undefined,
    flexWrap: undefined,
    alignSelf: undefined,
    alignContent: undefined,
    alignItems: undefined,
    justifyContent: undefined,
  },
  meta: {
    extendable: false,
  },
}
